import {
    useBxpWebStargateClient,
    BitbucketWorkspacesResponse,
    BitbucketWorkspaceOptions
} from "@/libraries/bxp-web-stargate-client/src/index";

import { AsyncResult, useAsync } from "./use-async";

type UseBitbucketWorkspacesTypeOptions = {
    readonly makeRequest?: boolean;
} & BitbucketWorkspaceOptions;

export function useBitbucketWorkspaces({
    nextUrl,
    urlQuery,
    makeRequest
}: UseBitbucketWorkspacesTypeOptions): AsyncResult<BitbucketWorkspacesResponse | null> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(
        () =>
            makeRequest
                ? stargateClient.bitbucketWorkspaces({ nextUrl, urlQuery })
                : Promise.resolve(null),
        [makeRequest]
    );
}
